export default __webpack_public_path__ + "static/media/best-place-for-remote-work.0b3a567a.jpg";